import { ViewController, ChannelSwitchEvent, ButtonClickEvent, FocusChangeEvent } from "@gaming/srvg-classes-core";
import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";
import { OverlayContainerContainerView } from "../../View/OverlayContainerContainerView";
import { GroupTablesGalleryViewController } from "./GroupTablesGalleryViewController";
import { TimelineOverlayContainerViewController } from "./TimelineOverlayContainerViewController";
import { OverlayButtonbarViewController } from "./OverlayButtonbarViewController";

export class OverlayContainerContainerViewController extends ViewController {
    overlayContainerContainerView: OverlayContainerContainerView;
    groupTablesGalleryViewController:GroupTablesGalleryViewController;
    timelineOverlayContainerViewController:TimelineOverlayContainerViewController;
    overlayButtonbarViewController:OverlayButtonbarViewController;

    constructor( options ) {
        options = options || {};
        options.view = options.overlayContainerContainerView|| null;
        super(options);

        this.overlayContainerContainerView = options.overlayContainerContainerView || null;
        //this.overlayContainerContainerView.setDelegate( this );

        this.groupTablesGalleryViewController = this.addChildViewController( new GroupTablesGalleryViewController(
            { galleryView: this.overlayContainerContainerView.manualOverlayContainerView.galleryView } )
        );
        this.timelineOverlayContainerViewController = this.addChildViewController(
            new TimelineOverlayContainerViewController({
                timelineOverlayContainerView: this.overlayContainerContainerView.timelineOverlayContainerView
            })
        );

        this.overlayButtonbarViewController = this.addChildViewController(new OverlayButtonbarViewController({
            overlayButtonbarView: this.overlayContainerContainerView.overlayButtonbarView
        }));

        app.timelineController.addSubscriberForEvent(this.timelineOverlayContainerViewController, PhaseChangeEvent);

        srvg.eventExchange.addEventHandler(this.timelineOverlayContainerViewController, 'all', ChannelSwitchEvent);

        this.overlayButtonbarViewController.addSubscriberForEvent(this, ButtonClickEvent);
        app.addSubscriberForEvent( this, FocusChangeEvent );
    }

    /**
     * Handles clicks of the statistics, table, and tree buttons.
     * FIXME make sure that the timelineOverlays are current when closing the manualOverlays and
     * showing the timelineOverlays
     */
    handleButtonClickEvent(event:ButtonClickEvent, provider) {
        this.log( 'handleButtonClickEvent' );

        var buttonBarView = this.overlayContainerContainerView.overlayButtonbarView;
        var statisticsButton = buttonBarView.statisticsButton;
        var tableButton = buttonBarView.tableButton;
        var rosterButton = buttonBarView.rosterButton;

        var manualOverlayContainerView = this.overlayContainerContainerView.manualOverlayContainerView;
        var timelineOverlayContainerView = this.overlayContainerContainerView.timelineOverlayContainerView;

        if (event.button == statisticsButton) {
            this.log( 'Button is statisticsButton' );

            // get home team id and away team id
            var homeId = app.timeline.currentChunkModel.chunk.matches[app.timeline.currentChannel].homeClubId;
            var awayId = app.timeline.currentChunkModel.chunk.matches[app.timeline.currentChannel].awayClubId;

            // get id of the currently running cup
            var currentCompetitionId = app.timeline.currentCompetitionModel.competition.id;

            app.customerIntegrationController.openStatisticHead2head(homeId, awayId, currentCompetitionId);
        }
        else if (event.button == tableButton || event.button == rosterButton) {
            if( event.button == tableButton ) {
                this.log( 'Pressed button is tableButton' );
            }
            else if( event.button == rosterButton ) {
                this.log( 'Pressed button is rosterButton' );
            }
            else {
                this.log( 'Pressed button is unknown' );
            }

            if (manualOverlayContainerView.isShown) {
                this.log( 'ManualOverlayContainer is being shown' );
                if (event.button.isSelected) {
                    this.log( 'MANUAL OVERLAY OFF' );

                    manualOverlayContainerView.hide(true);

                    this.timelineOverlayContainerViewController.mayBeShown = true;
                    if (this.timelineOverlayContainerViewController.shouldBeShown) {
                        timelineOverlayContainerView.show(true);
                    }
                    buttonBarView.deselectSubView(event.button);
                }
                else {
                    this.log( 'Switching view' );
                    if (event.button == tableButton) {
                        this.log( 'Switching to table' );

                        // As the galleryView shall remain at the initially set groups and no change with
                        // every chunk change we set this flag to true when the overlay is shown
                        // this flag is reset in CupViewController when overlay is hidden
                        this.groupTablesGalleryViewController.galleryView.galleryPageContainerView.showSpecific(this.groupTablesGalleryViewController.pairOfGroupsToBeHighlighted);

                        manualOverlayContainerView.showOnlySubView(
                            manualOverlayContainerView.galleryView,
                            true
                        );
                    }
                    else if (event.button == rosterButton) {
                        this.log( 'Switching to roster' );
                        const roster = this.checkRoster(manualOverlayContainerView);
                        manualOverlayContainerView.showOnlySubView(
                            //roster or cuproster
                            roster,
                            true
                        );
                    }
                    buttonBarView.selectOnlySubView(event.button);
                }
            }
            else {
                this.log( 'ManualOverlayContainer is not being shown' );
                if (event.button == tableButton) {
                    this.log( 'Showing table' );

                    // As the galleryView shall remain at the initially set groups and no change with
                    // every chunk change we set this flag to true when the overlay is shown
                    // this flag is reset in CupViewController when overlay is hidden
                    this.groupTablesGalleryViewController.galleryView.galleryPageContainerView.showSpecific(this.groupTablesGalleryViewController.pairOfGroupsToBeHighlighted);

                    manualOverlayContainerView.showOnlySubView(
                        manualOverlayContainerView.galleryView,
                        false
                    );
                }
                else if (event.button == rosterButton) {
                    this.log( 'Showing roster' );
                    const roster = this.checkRoster(manualOverlayContainerView);
                    manualOverlayContainerView.showOnlySubView(
                        //roster or cuproster
                        roster,
                        true
                    );
                }
                this.log( 'MANUAL OVERLAY ON' );
                manualOverlayContainerView.show(true);
                this.timelineOverlayContainerViewController.mayBeShown = false;
                timelineOverlayContainerView.hide(true);

                buttonBarView.selectOnlySubView(event.button);
            }
        }
    }

    checkRoster(manualOverlayContainerView){
        if(srvg.widgets.widgets['roster'].enabled)
            return manualOverlayContainerView.rosterWidget;
        else if (srvg.widgets.widgets['cuproster'].enabled)
            return manualOverlayContainerView.cuprosterWidget;
    }

    handleFocusChangeEvent(event:FocusChangeEvent, provider) {
        this.log( 'handleFocusChangeEvent' );
        if( event.hasFocus ) {
            if( !this.timelineOverlayContainerViewController.shouldBeShown || ! this.timelineOverlayContainerViewController.mayBeShown ) {
                if( this.timelineOverlayContainerViewController.timelineOverlayContainerView.isShown ) {
                    this.timelineOverlayContainerViewController.timelineOverlayContainerView.hide( true );
                }
            }
        }
    }
}